var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{attrs:{"false-value":false,"true-value":true},model:{value:(_vm.isComplete),callback:function ($$v) {_vm.isComplete=$$v},expression:"isComplete"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }